import React, { useState, useEffect } from "react";
import less from "./sosModal.module.scss";
import SliderButton from "../../Slider";
const SOSModal = ({ show, onClose, onConfirm, onOptionSelect }) => {
  useEffect(() => {
    if (!show) return;

    const scrollY = window.scrollY;

    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";

    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";

      window.scrollTo(0, scrollY);
    };
  }, [show]);

  const [step, setStep] = useState(1);
  const [reason, setReason] = useState("");

  const onCancel = () => {
    setStep(1);
    setReason("");
    onClose();
  };

  if (!show) return null;

  return (
    <div className={less["sos-overlay"]}>
      <div className={less["sos-card"]}>
        <button className={less["sos-close"]} onClick={onCancel}>
          ×
        </button>

        <div className={less["sos-header"]}>
          <img
            src="https://d1flzashw70bti.cloudfront.net/next-gen/images/sos/siren.webp"
            alt="SOS"
            className={less["sos-icon"]}
          />
          <div>
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/SOS/heading.svg"
              alt="SOS Heading"
            />
            <span>EMERGENCY</span>
          </div>
          <p>
            Initiate SOS services only in case of an emergency. Our team will
            try to reach you as soon as possible.
          </p>
        </div>

        {/* STEP 1 — Select Reason */}
        {step === 1 && (
          <div className={less["sos-body"]}>
            <span>Please choose the reason</span>

            {[
              "Bus missed",
              "Feeling unsafe in bus",
              "Breakdown of bus",
              "Accident",
              "Not Feeling well",
              "Unsafe Rest stop"
            ].map(item => (
              <label key={item} className={less["sos-option"]}>
                <input
                  type="radio"
                  name="reason"
                  value={item}
                  onChange={() => setReason(item)}
                />
                {item}
              </label>
            ))}

            <button
              className={less["sos-submit"]}
              disabled={!reason}
              onClick={() => {
                setStep(2);
                onOptionSelect();
              }}
            >
              Submit Reason
            </button>

            <button className={less["sos-exit"]} onClick={onClose}>
              Exit
            </button>
          </div>
        )}

        {/* STEP 2 — Slider Confirmation */}
        {step === 2 && (
          <div className={less["sos-body"]}>
            <span>
              Are you sure you want to initiate SOS because you feel: <br />
              <b>{reason}</b>?
            </span>

            <div className={less["sos-slider-container"]}>
              <SliderButton
                label="Initiate SOS"
                onComplete={() => {
                  onConfirm(reason);
                  // onClose();
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SOSModal;
